import axios from 'axios';
import { ENV } from '../config/env';
import requestInteceptor from './interceptor/requestInterceptor';
// Create instance called instance
const axiosInstance = axios.create({
  baseURL: ENV.prod,
  timeout: 90000,
});

axiosInstance.interceptors.request.use(
  (config) => requestInteceptor(config),
  (error) => {
    return Promise.reject(error);
  },
);

export const instance = axiosInstance;
